export default __webpack_public_path__ + "static/media/IMG-20240708-WA0013.abe4aef8.jpg";